"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = FormSubmitButton;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _reactstrap = require("reactstrap");

var _form = require("@sharingapples/form");

function FormSubmitButton(props) {
  var submit = (0, _form.useFormSubmit)();
  var color = props.color,
      icon = props.icon,
      buttonText = props.buttonText,
      onSubmit = props.onSubmit,
      rest = (0, _objectWithoutProperties2["default"])(props, ["color", "icon", "buttonText", "onSubmit"]);
  var handleSubmit = (0, _react.useCallback)(
  /*#__PURE__*/
  (0, _asyncToGenerator2["default"])(
  /*#__PURE__*/
  _regenerator["default"].mark(function _callee() {
    var result;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return submit();

          case 2:
            result = _context.sent;

            if (result) {
              onSubmit();
            }

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })), [submit, onSubmit]);
  return _react["default"].createElement(_reactstrap.Button, (0, _extends2["default"])({
    onClick: handleSubmit,
    color: color
  }, rest), icon && _react["default"].createElement("i", {
    className: icon
  }), " ", buttonText);
}

FormSubmitButton.defaultProps = {
  icon: '',
  color: 'yellow',
  onSubmit: function onSubmit() {}
};